module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-flat-screen2@2x-7a5b4505908793bf8f8569513190260b.png";